import React from 'react';
import '../styles/Navbar.css';

function Navbar() {
  return (
    <nav className="navbar">
      <div className="logo">
        <span className="logo-text">PropScan</span>
        <span className="logo-dot">.</span>
        <span className="logo-ai">AI</span>
      </div>
    </nav>
  );
}

export default Navbar; 